export type EmailRecipient = {
	RecipientId: number | null;
	DisplayName: string;
	EmailAddress: string;
	IsActive: boolean;
	CreatedBy?: string | null;
	CreatedTimestamp?: string | null;
	UpdatedBy?: string | null;
	UpdatedTimestamp?: string | null;
	TemplateCount?: number;
};

export const EMAIL_RECIPIENT_INITIAL_VALUES: EmailRecipient = {
	RecipientId: null,
	DisplayName: "",
	EmailAddress: "",
	IsActive: true,
};

/** A row of the template picker: the address book plus whether this template notifies it. */
export type TemplateRecipient = EmailRecipient & { IsSelected: boolean };

export type ModalMode = "new" | "edit" | "delete" | "";
